import { render, staticRenderFns } from "./MessageTranscript.vue?vue&type=template&id=7df4f062&scoped=true"
import script from "./MessageTranscript.vue?vue&type=script&lang=js"
export * from "./MessageTranscript.vue?vue&type=script&lang=js"
import style0 from "./MessageTranscript.vue?vue&type=style&index=0&id=7df4f062&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df4f062",
  null
  
)

export default component.exports